import theodorePic from "@/public/images/artists/theodore.png";
import { Artist } from "@/types/types";

export const theodore = {
  id: "115",
  name: "Theodore",
  image: theodorePic,
  description: `Theodore's voice carries a unique acoustic signature, featuring a resonant baritone timbre accented by a noticeable raspiness. His vocal range spans wide, particularly excelling in the lower octaves.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftheodore-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Soul", "Mature", "Deep", "Funk"],
      secondary: ["Old School", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 36,
        high: 63,
      },
      sweetSpot: 48,
    },
  },
} as const satisfies Artist;
